export const PRINTER_TYPE = {
    EPSON: 'epson',
    SUNMI: 'sunmi',
    CLOUDPRINT: 'cloudprint',
    WEBPRINT: 'WEBPRNT',
    QZ: 'QZ'
};